import React from 'react';
import { Button } from 'react-bootstrap';
import InitiativeParticipationStatus from '../../initiatives/InitiativeParticipationStatus.jsx';
import InitiativeDateColumn from '../../initiatives/InitiativesTable/InitiativeDateColumn.jsx';
import { InitiativeLink, ProjectLink } from '../../links/index.jsx';
import { getOrgSlug } from '../../../lib/utils.js';

const InitiativeParticipationsTableRow = ({
  initiativeParticipation,
  showMandatory,
  showCompletion,
}) => {
  const { initiative, surveyResponse } = initiativeParticipation;

  const handleClickViewFeedbackResponse = () => {
    if (initiative) {
      window.open(
        `/${getOrgSlug()}/${initiative.type}/${initiative.id}/change-insights/${initiative.surveyId}/results/${surveyResponse.id}`,
        '_blank'
      );
    }
  };

  return (
    <tr>
      <td>
        <h3>
          <InitiativeLink initiative={initiative}>
            <a>{initiative.title}</a>
          </InitiativeLink>
        </h3>
      </td>
      <td>
        <ProjectLink projectId={initiative.project.id}>
          {initiative.project.name}
        </ProjectLink>
      </td>
      <td>
        <strong
          className={`${initiative.category.archived ? 'text-muted' : ''}`}
        >
          {initiative.category.name}
        </strong>
      </td>
      {/* {showCompletion && ( */}
      {/*  <td> */}
      {/*    <InitiativeParticipationStatus */}
      {/*      initiative={initiative} */}
      {/*      initiativeParticipation={initiativeParticipation} */}
      {/*    /> */}
      {/*  </td> */}
      {/* )} */}
      {/* {showMandatory && ( */}
      {/*  <td> */}
      {/*    <strong>{initiative.mandatory ? 'Yes' : 'No'}</strong> */}
      {/*  </td> */}
      {/* )} */}
      <td>
        {showCompletion ? (
          <InitiativeParticipationStatus
            initiative={initiative}
            initiativeParticipation={initiativeParticipation}
          />
        ) : (
          <strong>—</strong>
        )}
      </td>
      <td>
        {showMandatory ? (
          <strong>{initiative.mandatory ? 'Yes' : 'No'}</strong>
        ) : (
          <strong>—</strong>
        )}
      </td>
      <td>
        {surveyResponse ? (
          <a
            onClick={handleClickViewFeedbackResponse}
            className="strong cursor-pointer"
          >
            View
          </a>
        ) : (
          <strong>—</strong>
        )}
      </td>
      <td>
        <strong>{initiative.lead}</strong>
      </td>
      <InitiativeDateColumn initiative={initiative} />
      <td className="text-right">
        <InitiativeLink initiative={initiative}>
          <Button bsStyle="primary">View</Button>
        </InitiativeLink>
      </td>
    </tr>
  );
};

export default InitiativeParticipationsTableRow;
